import script from "./leave-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./leave-report-table.vue?vue&type=script&setup=true&lang=js"

import "./leave-report-table.vue?vue&type=style&index=0&id=74e24b64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e24b64"]])

export default __exports__